import { useState } from 'react';
import PriorityForm from './PriorityForm';
import Popup from './../../components/Popup';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PriorityQueries from './PriorityQueries';
import { PriorityItemDto } from '../../api';
import { Employee } from '../../models/Employee';
import { LightToolTip } from '../../components/form/react-hook-form-components/ToolTipTheme';

interface ICreatePriorityProps {
  employee?: Employee;
  order: number;
}

export default function CreatePriorityButton(props: ICreatePriorityProps) {
  const { employee, order } = props;
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const { mutateCreatePriority } = PriorityQueries();
  const popupTitle = employee ? `Create Priority for ${employee.firstName} ${employee.lastName}` : 'Create Priority';
  const { HasPermissionToEdit } = PriorityQueries();
  let { data: permission } = HasPermissionToEdit(employee?.id!);

  return (
    <div>
      {permission && (
        <LightToolTip title="Create" placement="bottom">
          <Button
            variant="contained"
            color="tertiary"
            size="small"
            sx={{ minWidth: 1 }}
            onClick={() => setIsCreateFormOpen(true)}
          >
            <AddIcon />
          </Button>
        </LightToolTip>
      )}
      <Popup title={popupTitle} openPopup={isCreateFormOpen} setOpenPopup={setIsCreateFormOpen}>
        <PriorityForm
          employee={employee}
          order={order}
          onSubmit={(priority: PriorityItemDto) => {
            mutateCreatePriority(priority, {
              onSuccess: () => setIsCreateFormOpen(false),
            });
          }}
          onCancel={() => setIsCreateFormOpen(false)}
        />
      </Popup>
    </div>
  );
}
